import { DataAccessSearchItem } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityDataAccessSearchUserRequest = {
	queryString: string;
};

export type GetDataSecurityDataAccessSearchUserResponse = Array<DataAccessSearchItem>;

export const getDataSecurityDataAccessSearchUser =
	createGetEndpoint<GetDataSecurityDataAccessSearchUserRequest, GetDataSecurityDataAccessSearchUserResponse>(
		(request) => `/api/v3/salesforce/data-access/search-user?${getQueryString(request)}`
	);
